import axios from 'axios';
import { StoreType } from '../app/store';
import { logout } from '../features/auth/authSlice';

const setupAxiosInterceptor = (store: StoreType) => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        store.dispatch(logout());
      } else {
        return Promise.reject(error);
      }
    }
  );
};

export default setupAxiosInterceptor;
